package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.showSelectedDate
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

@Composable
fun CalendarBox(
    modifier: Modifier = Modifier,
    fillMaxWidth:Boolean=false,
    selectedDate: MonthModel ? ,
    label:String,
    width: CSSSizeValue<CSSUnit.px> = Dimen.mediumEditTextWidth,
    onClick:()->Unit,
) {

    OutlinedBox(
        modifier = modifier,
        fillMaxWidth = fillMaxWidth,
        label = label,
        width =width,
        iconPath = Res.PathIcon.calendar,
        boxContent = {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight(),
                verticalAlignment = Alignment.CenterVertically
            )
            {
                SpanText(
                    text =if (selectedDate==null) ""
                    else showSelectedDate(selectedDate = selectedDate),
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding)
                        .fontSize(FontSizes.mediumFontSize)
                        .fontFamily(FontFamily.Jakarta)
                        .fontWeight(FontWeight.Normal)
                        .color(Theme.TextPrimary.rgb)
                )

            }
        },
        onClick = {
            onClick()
        },
    )


}